export default {
  draggedObject: (state) => state.draggedObject,
  isDraggingObject: (state) => state.isDraggingObject,
  highlightedOffers: (state) => state.highlightedOffers,
}
